import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69c0e7967d947e00146843ba/showcrm/src/app/dashboard/components/DashboardContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69c0e7967d947e00146843ba/showcrm/src/components/Sidebar.tsx");
